import React, { useEffect, useMemo } from 'react'
// import { Link } from "react-router-dom";
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setRecord, setTableData } from './store/dataSlice'
// import { HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";
// import Tooltip from "components/Ui/Tooltip";
import {
    // ConfirmationModal,
    Table,
} from 'components/Ui'
import { getApiData } from 'services/ShipmentsService'
// import { Success } from "utils/alerts";
// import useAuth from "utils/hooks/useAuth";
// import { carrier, carrierService, orderType, siteLabel, status } from 'components/helper'
import dayjs from 'dayjs'
import { DatePicker, Select } from 'components/Form'
injectReducer('shipments', reducer)

export default function Shipments() {
    const dispatch = useDispatch()
    // const { checkPermission } = useAuth();
    const { data, tableData, loading } = useSelector(state => state.shipments.data)
    const { company, customer } = useSelector(state => state.filterData)
    const { companyData, customersData, wmsOrderStatusFilterData } = useSelector(state => state.listData)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        tableData.startDate,
        tableData.endDate,
        tableData.status,
        company,
        customer,
    ])

    const fetchData = () =>
        dispatch(
            getData({
                ...tableData,
                company: company ? companyData?.find(item => item?.id?.toString() === company?.toString())?.code : '',
                customer: customer
                    ? customersData?.find(item => item?.id?.toString() === customer?.toString())?.customer_code
                    : '',
            })
        )

    const filterData = () => {
        const sort = tableData?.sort || []
        let filtered = data?.filter(item => {
            // if (customer) {
            //     return item?.customer?.toString() === customer
            // }
            return true
        })

        if (sort?.length > 0) {
            sort?.forEach(({ column, dir }) => {
                filtered = filtered?.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }
        return filtered || []
    }

    //   const handleDelete = (id) => {
    //     deleteApiRecord(id)
    //       .then(() => {
    //         Success("Deleted Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    //   const handleStatus = (id, data) => {
    //     delete data.image;
    //     updateApiRecord(id, data)
    //       .then(() => {
    //         Success("Status Updated Successfully!");
    //         fetchData();
    //       })
    //       .catch((error) => console.log("Error: ", error));
    //   };

    const columns = useMemo(
        () => [
            {
                field: 'warehouseId',
                header: 'Whse',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'organizationId',
                header: 'Company',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'customerId',
                header: 'Customer',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'deliveryNo',
                header: 'Tracking Number',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'orderNo',
                header: 'Order No',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'orderType',
                header: 'Order Type',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'soReference1',
                header: 'Reference 1',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'consigneeName',
                header: 'Consignee',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'codeDescr',
                header: 'Order Status',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'orderTime',
                header: 'Created Date',
                className: 'min-w-[150px]',
                renderCell: row => (row?.orderTime ? dayjs(row?.orderTime).format('MMM D, YYYY') : ''),
                orderable: true,
            },
            {
                field: 'lastShipmentTime',
                header: 'Closed Date',
                className: 'min-w-[150px]',
                renderCell: row => (row?.lastShipmentTime ? dayjs(row?.lastShipmentTime).format('MMM D, YYYY') : ''),
                orderable: true,
            },
            //   {
            //     header: "Status",
            //     renderCell: (row) => {
            //       return checkPermission("company", "status") ? (
            //         <ConfirmationModal
            //           onConfirm={() => {
            //             handleStatus(row.id, { ...row, is_active: !row.is_active });
            //           }}
            //         >
            //           {status(row.is_active)}
            //         </ConfirmationModal>
            //       ) : (
            //         status(row.is_active)
            //       );
            //     },
            //   },
            //   {
            //     header: "Action",
            //     className: "px-4",
            //     renderCell: (row) => {
            //       return (
            //         <div className="flex items-center gap-3">
            //           {checkPermission("company", "edit") ? (
            //             <Tooltip title={"Edit"}>
            //               <Link
            //                 to={`/company/${row.id}/edit`}
            //                 className="hover:text-primary"
            //               >
            //                 <HiOutlinePencil size={20} />
            //               </Link>
            //             </Tooltip>
            //           ) : null}
            //           {checkPermission("company", "delete") ? (
            //             <Tooltip title={"Delete"}>
            //               <ConfirmationModal
            //                 message={"Are you sure you want to delete this record!"}
            //                 onConfirm={() => {
            //                   handleDelete(row.id);
            //                 }}
            //               >
            //                 <span className="hover:text-danger">
            //                   <HiOutlineTrash size={20} />
            //                 </span>
            //               </ConfirmationModal>
            //             </Tooltip>
            //           ) : null}
            //         </div>
            //       );
            //     },
            //   },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            tableData.startDate,
            tableData.endDate,
            tableData.status,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Shipments</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <Select
                    id="status"
                    name="status"
                    label="Status"
                    placeholder={'Status'}
                    value={tableData.status}
                    className="min-w-28"
                    options={wmsOrderStatusFilterData}
                    onChange={e => dispatch(setTableData({ ...tableData, status: e.target.value }))}
                />
                <DatePicker
                    id="satrt_date"
                    name="satrt_date"
                    label="Created Date"
                    placeholder="Start Date"
                    value={tableData.startDate}
                    onChange={e => dispatch(setTableData({ ...tableData, startDate: e.target.value }))}
                    className="w-full"
                />
                <DatePicker
                    id="end_date"
                    name="end_date"
                    label="Closed Date"
                    placeholder="End Date"
                    value={tableData.endDate}
                    onChange={e => dispatch(setTableData({ ...tableData, endDate: e.target.value }))}
                    className="w-full"
                />
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <Table
                    loading={loading}
                    filter={false}
                    download={true}
                    datas={filterData()}
                    columns={columns}
                    pagingData={tableData}
                    onChange={e => dispatch(setTableData(e))}
                    csvDownloadApi={getApiData}
                    view={'/meson-wms/shipments/'}
                    setRecord={setRecord}
                    viewId={'orderNo'}
                />
            </div>
        </>
    )
}
